import $ from 'jquery';
import debounce from 'debounce';
function backToTop() {
  if ($(this).scrollTop() > 150) {
    $('.back-to-top').addClass('fadeIn');
  } else {
    $('.back-to-top').removeClass('fadeIn');
  }
}
$(window).scroll(debounce(backToTop, 100));